<template>
	<div :class="isLoggedIn ? 'wrapper d-flex align-items-stretch route-' + $router.currentRoute.name : ''">
		<Header />
		<div id="content" :class="isLoggedIn ? 'side-nav-active' : ''" style="position: relative;">
			<router-view></router-view>

			<!-- Global Duplication Overlay (inside content area) -->
			<DuplicationOverlay />
		</div>

		<div id="global-spinner" v-show="dataLoading && onlyOneSpinner()">
			<b-spinner label="Loading"></b-spinner>
		</div>

				<!-- Modal for duplication -->
				<b-modal v-model="duplicateDeliverableModalVisible" id="duplicateDeliverableModal" size="lg"
				  :title="duplicatingDeliverable.status === 'completed' ? 'Duplication Complete' : 'Duplicate Organic Social Media Plan'"
				  :ok-title="duplicatingDeliverable.status === 'completed' ? 'View' : 'Duplicate'"
				  @ok="onDuplicateOrganicSocialMedia" @cancel="onCancelDuplicateOrganicSocialMedia">
				  <div v-if="duplicatingDeliverable.beforeTotal > 0" class="text-center">
				    <p class="mt-3 duplicate-progress-count">{{ duplicatingDeliverable.message }}</p>
				  </div>
				  <div v-else-if="duplicatingDeliverable.status === 'processing' || duplicatingDeliverable.status === 'pending'" class="text-center">
				    <b-progress :value="duplicatingDeliverable.progress" class="mb-3 duplicate-progress-bar" height="20px"></b-progress>
				      <div class="duplicate-progress-message">
				        <span v-if="duplicateDeliverableProgressCount" class="duplicate-progress-count">{{ duplicateDeliverableProgressCount }}</span>
				        <span class="duplicate-progress-text">{{ duplicatingDeliverable.message }}</span>
				        <span v-if="duplicateProgressLabel" class="duplicate-progress-label">{{ duplicateProgressLabel }}</span>
				      </div>
				    <p v-if="duplicatingDeliverable.status === 'pending'" class="text-muted">
				      <small>Another item is being duplicated. Your request will begin shortly.</small>
				    </p>
				  </div>

				  <div v-else-if="duplicatingDeliverable.status === 'completed'" class="text-center">
				    <i class="fas fa-check-circle text-success" style="font-size: 3rem;"></i>
				    <p class="mt-3 duplicate-progress-message">{{ duplicatingDeliverable.message }}</p>
				  </div>

				  <div v-else-if="duplicatingDeliverable.status === 'failed'" class="text-center">
				    <i class="fas fa-times-circle text-danger" style="font-size: 3rem;"></i>
				    <p class="mt-3" style="font-weight: bold;">A system error occurred. Duplication failed.</p>
				    <p class="text-muted">
				      An error notification has been sent to Pattern Interactive.
				    </p>
				  </div>

				  <div v-else>
				  	<p>Are you sure you want to duplicate this deliverable and all social media posts within it?</p>
				  </div>

				  <template #modal-footer="{ ok, cancel }">
				    <b-button @click="cancel()" v-if="duplicatingDeliverable.status !== 'processing'">
				      {{ duplicatingDeliverable.status === 'completed' ? 'Close' : 'Cancel' }}
				    </b-button>
				    <b-button variant="success" @click="ok()"
				      :disabled="duplicatingDeliverable.status === 'processing' || duplicatingDeliverable.status === 'failed'">
				      {{ duplicatingDeliverable.status === 'completed' ? 'View' : 'Duplicate' }}
				    </b-button>
				  </template>
				</b-modal>



		<b-modal centered hide-footer v-model="showSocialMediaExportModal" id="socialMediaExportModal"
			title="Creating Social Media Export">

			<div style="text-align:center">
				<b-spinner v-if="isLoadingExport" label="Loading"></b-spinner>
				<div v-if="!isLoadingExport">
					<a class="btn btn-primary" v-if="downloadLink" :href="downloadLink"
						@click="showSocialMediaExportModal = false;">Download</a>
				</div>
			</div>
		</b-modal>
		<b-modal centered hide-footer hide-backdrop no-close-on-backdrop content-class="shadow"
			v-model="showSocialMediaImportModal" id="socialMediaImportModal" title="Import Social Media Posts">
			<p><a href="/assets/import-social-media.xlsx" target="_blank">Download example .xlsx file</a></p>
			<VueFilePond name="file" ref="importPond" label-idle="Upload .xlsx" :allow-multiple="true"
				:dropOnElement="true" :dropOnPage="false" :allowRevert="false" v-bind:files="filepond"
				v-on:init="handleFilePondInit" credits="false" />
			<div class="imported-results" v-show="loadedImportResults">
				<b-button v-b-toggle.collapse-import-results variant="text">
					<i v-show="!expandImportResults" class="fas fa-chevron-down collapse-indicator"></i>
					<i v-show="expandImportResults" class="fas fa-chevron-right collapse-indicator"></i>
					<strong style="color:var(--error--color--border)" v-if="importedResults.errors.length > 0">ERROR:
						{{ importedResults.errors.length }} row(s) have problems.</strong>
					<strong>{{ importedResults.imported.length }} posts imported.</strong>
					<strong>{{ importedResults.total }} data rows in file.</strong>
					<strong>Click to view details.</strong>
					<br />
				</b-button>
				<b-collapse id="collapse-import-results" v-model="expandImportResults">
					<div class="collapse-inner">

						<ol v-if="importedResults.errors.length > 0">
							<li :class="`{e.new ? 'imported-new':'imported-existing'}`"
								v-for="(e, indexe) in importedResults.errors">
								<span class='imported-title'>{{ e.title }}</span>
								<span class='imported-publish_date' v-if="e.publish_date != null">{{ e.publish_date |
									moment("MMM D,YYYY HH:mm a")}}</span>
								<span class='imported-publish_date' v-if="e.publish_date == null">No Date Set</span>
								<span class='imported-social_campaign' v-if="e.social_campaign">Campaign:
									{{ e.social_campaign.title }}</span>
								<span class='imported-social_series' v-if="e.social_series">Series:
									{{ e.social_series.title }}</span>

								<span :class="getImportStatusClass(e.status)">Row {{ e.row }}; {{ e.status.name }}</span>
							</li>
						</ol>

						<ol v-if="importedResults.imported.length > 0">
							<li :class="`{s.new ? 'imported-new':'imported-existing'}`"
								v-for="(s, index) in importedResults.imported">
								<span class='imported-title'> <a
										@click="showEditDeliverableModal(s)">{{ s.title }}</a></span>
								<span class='imported-publish_date' v-if="s.publish_date != null">{{ s.publish_date |
									moment("MMM D,YYYY HH:mm a")}}</span>
								<span class='imported-publish_date' v-if="s.publish_date == null">No Date Set</span>

								<span class='imported-social_campaign' v-if="s.social_campaign">Campaign:
									{{ s.social_campaign.title }}</span>
								<span class='imported-social_series' v-if="s.social_series">Series:
									{{ s.social_series.title }}</span>

								<span :class="getImportStatusClass(s.status)">Row {{ s.row }}; {{ s.status.name }}</span>
							</li>
						</ol>
					</div>
				</b-collapse>
			</div>

		</b-modal>
	</div>
</template>
<script>
import Header from "@/csmworkflow/js/components/common/Header";
import DuplicationOverlay from "@/csmworkflow/js/components/common/DuplicationOverlay";
import { mapActions, mapGetters, mapState } from 'vuex';
import vueFilePond from "vue-filepond";
import toast from "../toast";
const VueFilePond = vueFilePond();
import "filepond/dist/filepond.min.css";


export default {
	data() {
		return {
			namespace: "",
			expandImportResults: false,
			importedResults: {
				imported: [],
				errors: [],
				total: 0
			},
			loadedImportResults: false,
			filepond: [],
			showSocialMediaExportModal: false,
			showSocialMediaImportModal: false,
			isLoadingImport: false,
			isLoadingExport: false,
			importFilterQuery: null,
			downloadError: null,
			downloadLink: null,
			importError: null,
			activeJobKey: null,
			duplicateModalVisible: false,  // Track if duplicate modal is open
			duplicateDeliverableModalVisible: false,  // Track if duplicate deliverable modal is open
		}
	},
	computed: {
		...mapGetters([
			'dataLoading',
			'preferenceData',
			"systemSettings",
			'duplicatingDeliverable',
		]),
		...mapActions([
			'startDownloadDeliverableExcel'
		]),
		...mapState({
			deliverableDetail(state, getters) {
				return getters[this.namespace + 'deliverableDetail']
			},
		}),
		isLoggedIn() {
			if (this.$router.currentRoute.name == 'dashboardMediaCalls') {
				return true;
			} else {
				return this.$store.getters.isLoggedIn;
			}
		},
		duplicateDeliverableProgressCount() {
		  if (!this.duplicatingDeliverable.progressDetails || !this.duplicatingDeliverable.progressDetails.total) {
		    return null;
		  }
		  const completed = this.duplicatingDeliverable.progressDetails.completed ?? 0;
		  const total = this.duplicatingDeliverable.progressDetails.total ?? 0;
		  return `${completed}/${total}`;
		},
		duplicateProgressLabel() {
		  if (!this.duplicatingDeliverable.progressDetails || !this.duplicatingDeliverable.progressDetails.label) {
		    return null;
		  }
		  return this.duplicatingDeliverable.progressDetails.label;
		},
	},
	components: {
		Header,
		DuplicationOverlay,
		VueFilePond,
	},
	methods: {
		...mapActions([
			'fetchSystemSettings',
			'fetchAllCompanies',
			'fetchUserPermissions',
			'fetchAlerts',
			'fetchUserAlerts',
			'fetchNotification',
			'fetchUserProjectsCount',
			'fetchAllProjects',
			'getPreference',
			"fetchWidgetSettings",
			'checkActiveJobs',
			'getJobStatus',
			'cancelDuplicateJob',
		]),

			onDuplicateOrganicSocialMedia(bvModalEvent) {
			  console.log("this.$router.currentRoute.name", this.$router.currentRoute.name);
			  if (this.$store.getters.duplicatingDeliverable.status === 'completed') {
			  	switch(this.$router.currentRoute.name) {
			  		case "projectDeliverable":
  			  		if (this.$store.getters.duplicatingDeliverable.newDeliverableId !== null) {
  			  			if (this.$store.getters.duplicatingDeliverable.newProjectNumber != "") {
  					  		window.location.href = `/project/${this.$store.getters.duplicatingDeliverable.newProjectNumber}?deliverable=${this.$store.getters.duplicatingDeliverable.newDeliverableId}`;
  				  		}
  				  	}
  				  	break;
  				  case "dashboard":
  				  	window.location.href = `/all-deliverables/${this.$store.getters.duplicatingDeliverable.newDeliverableId}/view`;
  				  	break;
  				  case "dashboardDeliverableDetail":
  				  	window.location.href = `/all-deliverables/${this.$store.getters.duplicatingDeliverable.newDeliverableId}/view`;
  				  	break;
  				  case "myWeek":
  				  		window.location.href = `/my-week/${this.$store.getters.duplicatingDeliverable.newDeliverableId}/view`;
  				  		break;
  				 	case "myProjectDeliverable":
		 		  		if (this.$store.getters.duplicatingDeliverable.newDeliverableId !== null) {
		 		  			if (this.$store.getters.duplicatingDeliverable.newProjectNumber != "") {
		 				  		window.location.href = `/my-projects/${this.$store.getters.duplicatingDeliverable.newProjectNumber}?deliverable=${this.$store.getters.duplicatingDeliverable.newDeliverableId}`;
		 			  		}
		 			  	}
							break;
						case "socialMediaSchedule":
							window.location.href = `/social-media-schedule/${this.$store.getters.duplicatingDeliverable.newDeliverableId}?tab=1`;
							break;
						case "socialMediaCalendarDetail":
							window.location.href = `/social-media-calendar/${this.$store.getters.duplicatingDeliverable.newDeliverableId}`;
							break;
			  	}
				  return;
			  }

			  bvModalEvent.preventDefault();

			  this.$store.commit("setDuplicatingDeliverableStatus", "processing");
				this.$store.commit("setDuplicatingDeliverableMessage", "");
			  this.$store.commit("setDuplicatingDeliverableProgressDetails", null);
			  this.$store.commit("setDuplicatingDeliverableProgress", 0);



			  // Start listening for progress events
			  this.$root.$on('deliverableDuplicationJobProgress', this.handleDeliverableDuplicationJobProgress);
			  this.$root.$on('deliverableDuplicationJobInQueue', this.handleDeliverableDuplicationJobInQueue);
			  this.$store.dispatch('duplicateOrganicSocialMediaPlan', {
			  	deliverableId:this.$store.getters.duplicatingDeliverable.deliverableId,
			    ...this.duplicateOptions
			  }).then(response => {
			    if (response.data.success) {
			    	this.$store.commit("setDuplicatingDeliverableJobkey", response.data.job_key);

			      // Check if it's a silent fail (WebSocket not running)
			      if (response.data.silent_fail) {
			          this.$store.commit("setDuplicatingDeliverableStatus", "failed");
			        	this.$store.commit("setDuplicatingDeliverableMessage", "WebSocket server is not running. An error notification has been sent to Pattern Interactive.");
			        this.$root.$off('deliverableDuplicationJobProgress', this.handleDeliverableDuplicationJobProgress);
			        return;
			      }

			      // Show queue position message
			      if (response.data.queue_message) {
			        this.$store.commit("setDuplicatingDeliverableMessage", response.data.queue_message);
			      }

			      // Trigger global monitoring (single EventSource in App.vue)
			      var obj = { queuePosition: typeof response.data.queue_position === 'number' ? response.data.queue_position : null };
			      this.startGlobalDeliverableDuplicationJobMonitoring( response.data.job_key, obj);


			      // this.$root.$emit('startGlobalDeliverableDuplicationJobMonitoring', {
			      //   jobKey: response.data.job_key,
			      //   queuePosition: typeof response.data.queue_position === 'number' ? response.data.queue_position : null
			      // });
			    } else {
		        this.$store.commit("setDuplicatingDeliverableStatus", "failed");
		      	this.$store.commit("setDuplicatingDeliverableMessage", response.data.message || 'Duplication failed');

			      // Job failed, stop listening
			      this.$root.$off('deliverableDuplicationJobProgress', this.handleDeliverableDuplicationJobProgress);
			    }
			  }).catch(error => {
			      this.$store.commit("setDuplicatingDeliverableStatus", "failed");
			    	this.$store.commit("setDuplicatingDeliverableMessage", error.response?.data?.message || 'Duplication failed');


			    // Job failed, stop listening
			    this.$root.$off('deliverableDuplicationJobProgress', this.handleDeliverableDuplicationJobProgress);
			  });
			},
					  handleDeliverableDuplicationJobInQueue(data) {
					  	if (data.jobKey !== this.duplicatingDeliverable.jobKey) {
					  		 return;
					  	}

							this.$store.commit("setDuplicatingDeliverableBeforeTotal", data.queue_before);
							this.$store.commit("setDuplicatingDeliverableMessage", data.queue_message);
					  },
					  handleDeliverableDuplicationJobProgress(data) {
					    // Only handle progress for this modal's job
					    if (data.jobKey !== this.duplicatingDeliverable.jobKey) {
					      return;
					    }

					    if (data.status === 'pending') {
					      // Keep showing queue message for pending status
					      this.$store.commit("setDuplicatingDeliverableStatus", "processing");
					      this.$store.commit("setDuplicatingDeliverableProgress", 0);
					      this.$store.commit("setDuplicatingDeliverableProgressDetails", null);
					      // Don't override the queue message
					    } else if (data.status === 'processing') {
					      this.$store.commit("setDuplicatingDeliverableStatus", "processing");
					      this.$store.commit("setDuplicatingDeliverableProgress", Math.round(data.progress) || 0);
					      this.$store.commit("setDuplicatingDeliverableMessage", data.message || 'Processing...');
					      this.$store.commit("setDuplicatingDeliverableProgressDetails", data.progress_details || null);
					    } else if (data.status === 'completed') {

					      this.$store.commit("setDuplicatingDeliverableProgress", 100);
					      this.$store.commit("setDuplicatingDeliverableMessage",  data.message || 'Duplicated successfully!');
					      this.$store.commit("setDuplicatingDeliverableProgressDetails", null);
			      		this.$store.commit("setDuplicatingDeliverableNewDeliverableId", data.new_deliverable_id);
			      		this.$store.commit("setDuplicatingDeliverableNewProjectNumber", data.project_number);
			      		this.$store.commit("setDuplicatingDeliverableStatus", "completed");

					      // this.$store.dispatch('fetchAllProjects');
					      // Remove beforeunload warning since job is complete
					      // this.removeBeforeUnloadListener();
					      // Stop listening
					      this.$root.$off('deliverableDuplicationJobProgress', this.handleDeliverableDuplicationJobProgress);
					    } else if (data.status === 'failed') {
					      this.$store.commit("setDuplicatingDeliverableStatus", "failed");
					      this.$store.commit("setDuplicatingDeliverableMessage", data.error || 'Duplication failed');
					      this.$store.commit("setDuplicatingDeliverableProgressDetails", null);
					      // Remove beforeunload warning since job is no longer processing
					      // this.removeBeforeUnloadListener();
					      // Stop listening
					      this.$root.$off('deliverableDuplicationJobProgress', this.handleDeliverableDuplicationJobProgress);
					    }
					  },



		onCancelDuplicateOrganicSocialMedia() {
			console.log("onCancelDuplicateOrganicSocialMedia");
		},



			startGlobalDeliverableDuplicationJobMonitoring(jobKey, options = {}) {

			const ddchannel = window.Echo.channel(`deliverable-duplication.${jobKey}`);
			let ddjobTimeout = null;
			let failOnNoProgress = options.queuePosition === 0;
			const cleanup = () => {
				if (ddjobTimeout) {
					clearTimeout(ddjobTimeout);
				}
				window.Echo.leave(`deliverable-duplication.${jobKey}`);
				this.activeJobKey = null;
			};
			const ddfailDueToNoProgress = async () => {
				cleanup();
				try {
					await this.$store.dispatch('cancelDuplicateJob', jobKey);
				} catch (cancelError) {
					console.error('Failed to cancel job after timeout:', cancelError);
				}
				this.$root.$emit('deliverableDuplicationJobProgress', {
					jobKey: jobKey,
					status: 'failed',
					error: 'Queue worker is not running or not processing jobs. Job has been cancelled.',
					progress_details: null,
				});
			};

			const ddhandleTerminalStatus = (status, payload = {}) => {
				if (status === 'completed') {
					cleanup();
					if (!this.duplicateDeliverableModalVisible) {
						this.showCompletionToast(payload.project_number || payload?.data?.project_number);
					}
				} else if (status === 'failed') {
					cleanup();
					if (!this.duplicateDeliverableModalVisible) {
						this.showFailureToast(payload.error || payload?.data?.error);
					}
				}
			};

			const ddscheduleTimeoutCheck = () => {

				if (ddjobTimeout) {
					clearTimeout(ddjobTimeout);
				}

				ddjobTimeout = setTimeout(async () => {
					try {
						const ddstatusResponse = await this.$store.dispatch('getJobStatus', jobKey);
						if (ddstatusResponse.status === 'pending') {

							if (ddstatusResponse.queue_before) {
								if (ddstatusResponse.queue_before > 0) {
								  this.$root.$emit('deliverableDuplicationJobInQueue', {
								  	jobKey: jobKey,
								  	queue_before: ddstatusResponse.queue_before,
								  	status: ddstatusResponse.status,
								  	queue_message: ddstatusResponse.queue_message,
								  });
								}
							}

							if (failOnNoProgress) {
								await ddfailDueToNoProgress();
							} else {
								ddscheduleTimeoutCheck();
							}
							return;
						}
						// this.handleDeliverableDuplicationJobProgress({
						// 	jobKey: jobKey,
						// 	status: ddstatusResponse.status,
						// 	progress: ddstatusResponse.progress,
						// 	message: ddstatusResponse.data?.message,
						// 	project_number: ddstatusResponse.data?.project_number,
						// 	new_deliverable_id: ddstatusResponse.data?.new_deliverable_id ?? null,
						// 	deliverable_id: ddstatusResponse.data?.deliverable_id ?? null,
						// 	error: ddstatusResponse.data?.error,
						// 	progress_details: ddstatusResponse.data?.progress_details ?? null,
						// });

						this.$root.$emit('deliverableDuplicationJobProgress', {
							jobKey: jobKey,
							status: ddstatusResponse.status,
							progress: ddstatusResponse.progress,
							message: ddstatusResponse.data?.message,
							project_number: ddstatusResponse.data?.project_number,
							new_deliverable_id: ddstatusResponse.data?.new_deliverable_id ?? null,
							deliverable_id: ddstatusResponse.data?.deliverable_id ?? null,
							error: ddstatusResponse.data?.error,
							progress_details: ddstatusResponse.data?.progress_details ?? null,
						});
						ddhandleTerminalStatus(ddstatusResponse.status, ddstatusResponse);
						if (ddstatusResponse.status !== 'completed' && ddstatusResponse.status !== 'failed') {
							ddscheduleTimeoutCheck();
						}

					} catch (error) {
						console.error('Failed to verify job status:', error);
						ddscheduleTimeoutCheck();
					}
				}, 5000);
			};

			ddscheduleTimeoutCheck();
			ddchannel.listen('.progress', (data) => {
				ddscheduleTimeoutCheck();

				if (data.status === 'processing' || data.status === 'completed' || data.status === 'failed') {
					failOnNoProgress = false;
				}
				this.$root.$emit('deliverableDuplicationJobProgress', {
					jobKey: jobKey,
					status: data.status,
					progress: data.progress,
					message: data.message,
					project_number: data.project_number,
					new_deliverable_id: data.new_deliverable_id,
					deliverable_id: data.deliverable_id,
					error: data.error,
					progress_details: data.progress_details ?? null,
				});

				ddhandleTerminalStatus(data.status, data);
			})
				.error(async (error) => {
					console.error('WebSocket channel error:', error);
					cleanup();

					try {
						await this.$store.dispatch('cancelDuplicateJob', jobKey);
					} catch (cancelError) {
						console.error('Failed to cancel job:', cancelError);
					}

					this.$root.$emit('deliverableDuplicationJobProgress', {
						jobKey: jobKey,
						status: 'failed',
						error: 'Queue worker is not running or not processing jobs. Job has been cancelled.',
						progress_details: null,
					});
				});

			window.Echo.connector.pusher.connection.bind('state_change', function (states) {
				console.log('WebSocket state changed:', states.current);
			});
		},









		async checkForActiveJobs() {
			try {
				const response = await this.$store.dispatch('checkActiveJobs');

				if (response.has_active_job) {
					this.activeJobKey = response.job_key;
					this.startGlobalJobMonitoring(response.job_key);
				}
			} catch (error) {
				console.error('Error checking for active jobs:', error);
			}
		},

		startGlobalJobMonitoring(jobKey, options = {}) {
			const channel = window.Echo.channel(`project-duplication.${jobKey}`);
			console.log('WebSocket channel created:', channel);

			let jobTimeout = null;
			let failOnNoProgress = options.queuePosition === 0;

			const cleanup = () => {
				if (jobTimeout) {
					clearTimeout(jobTimeout);
				}
				window.Echo.leave(`project-duplication.${jobKey}`);
				this.activeJobKey = null;
			};

			const failDueToNoProgress = async () => {
				cleanup();
				try {
					await this.$store.dispatch('cancelDuplicateJob', jobKey);
				} catch (cancelError) {
					console.error('Failed to cancel job after timeout:', cancelError);
				}

				this.$root.$emit('duplicationJobProgress', {
					jobKey: jobKey,
					status: 'failed',
					error: 'Queue worker is not running or not processing jobs. Job has been cancelled.',
					progress_details: null,
				});
			};

			const handleTerminalStatus = (status, payload = {}) => {
				if (status === 'completed') {
					cleanup();
					this.$store.dispatch('fetchAllProjects');
					if (!this.duplicateModalVisible) {
						this.showCompletionToast(payload.project_number || payload?.data?.project_number);
					}
				} else if (status === 'failed') {
					cleanup();
					if (!this.duplicateModalVisible) {
						this.showFailureToast(payload.error || payload?.data?.error);
					}
				}
			};

			const scheduleTimeoutCheck = () => {
				if (jobTimeout) {
					clearTimeout(jobTimeout);
				}

				jobTimeout = setTimeout(async () => {
					console.log('No progress yet - verifying job status before timing out');
					try {
						const statusResponse = await this.$store.dispatch('getJobStatus', jobKey);

						if (statusResponse.status === 'pending') {

							if (statusResponse.queue_before) {
								if (statusResponse.queue_before > 0) {
								  this.$root.$emit('duplicationJobInQueue', {
								  	jobKey: jobKey,
								  	queue_before: statusResponse.queue_before,
								  	status: statusResponse.status,
								  	queue_message: statusResponse.queue_message,
								  });
								}
							}

							if (failOnNoProgress) {
								await failDueToNoProgress();
							} else {
								scheduleTimeoutCheck();
							}
							return;
						}

						this.$root.$emit('duplicationJobProgress', {
							jobKey: jobKey,
							status: statusResponse.status,
							progress: statusResponse.progress,
							message: statusResponse.data?.message,
							project_number: statusResponse.data?.project_number,
							error: statusResponse.data?.error,
							progress_details: statusResponse.data?.progress_details ?? null,
						});

						handleTerminalStatus(statusResponse.status, statusResponse);
						if (statusResponse.status !== 'completed' && statusResponse.status !== 'failed') {
							scheduleTimeoutCheck();
						}
					} catch (error) {
						console.error('Failed to verify job status:', error);
						scheduleTimeoutCheck();
					}
				}, 5000);
			};

			scheduleTimeoutCheck();

			channel.listen('.progress', (data) => {
				console.log('WebSocket progress received:', data);

				scheduleTimeoutCheck();

				if (data.status === 'processing' || data.status === 'completed' || data.status === 'failed') {
					failOnNoProgress = false;
				}

				this.$root.$emit('duplicationJobProgress', {
					jobKey: jobKey,
					status: data.status,
					progress: data.progress,
					message: data.message,
					project_number: data.project_number,
					error: data.error,
					progress_details: data.progress_details ?? null,
				});

				handleTerminalStatus(data.status, data);
			})
				.error(async (error) => {
					console.error('WebSocket channel error:', error);
					cleanup();

					try {
						await this.$store.dispatch('cancelDuplicateJob', jobKey);
					} catch (cancelError) {
						console.error('Failed to cancel job:', cancelError);
					}

					this.$root.$emit('duplicationJobProgress', {
						jobKey: jobKey,
						status: 'failed',
						error: 'Queue worker is not running or not processing jobs. Job has been cancelled.',
						progress_details: null,
					});
				});

			window.Echo.connector.pusher.connection.bind('state_change', function (states) {
				console.log('WebSocket state changed:', states.current);
			});
		},

		showCompletionToast(projectNumber) {
			const message = `<a href="/project/${projectNumber}" style="padding: 8px 16px; background: var(--wf-primary); color: white; text-decoration: none; border-radius: 4px; font-weight: 600;">View Project</a>`;

			toast.success(message, 'Duplication Complete', 5000);
		},

		showFailureToast(errorMessage) {
			toast.error(errorMessage || 'Project duplication failed', 'Duplication Failed');
		},

		onlyOneSpinner() {
			if ($("#global-spinner-above-list").length > 0) {
				return false;
			}
			if ($("#global-spinner-inline").length > 0) {
				return false;
			}
			return true;
		},

		onPostModalClose() {
			$('#content').removeClass('disable-pointer-events');
			$('#editOrganicSocialMediaPlanModal .modal-content').removeClass('disable-pointer-events');

			// make sure there isn't any calendar tooltips open.
			setTimeout(function () {
				$(".dhx_year_tooltip").hide();
			}, 0);
		},

		getImportStatusClass(status) {
			let css = "imported-status ";
			return css + "imported-status-" + status.slug;
		},

		// Resource upload file
		handleFilePondInit() {
			this.$refs.importPond._pond.setOptions({
				server: {
					headers: {
						Authorization: "Bearer " + this.$store.getters.authToken
					},
					process: {
						method: 'POST',
						url: `${this.apiUrl}importSocialMedia`,
						withCredentials: true,
						ondata: this.handleFilePondSubmit,
						onload: this.handleFilePondSuccess,
					},
				}
			});
		},
		handleFilePondSubmit(data) {
			this.isLoadingImport = true;
			this.loadedImportResults = false;
			this.importedResults = {
				imported: [],
				errors: []
			};
			data.filterQuery = this.importFilterQuery;

			return data;
		},
		handleFilePondSuccess(response, file) {
			this.importedResults = JSON.parse(response);
			for (var x = 0; x < 10; x++) {
				for (var y = 0; y < this.importedResults.length; y++) {
					this.importedResults.imported.push(this.importedResults.imported[$y]);
				}
				if (this.importedResults.imported.length > 20) {
					break;
				}
			}
			this.isLoadingImport = false;
			this.loadedImportResults = true;
			if (file) {
				this.$nextTick(() => {
					this.$refs.importPond.removeFile(file.id);
				});
			}

		},

		checkOrganicSocialMediaPlanDuplicationStatus(deliverableId) {
			if (!deliverableId) return;

			axios.get(`/api/v1/checkOrganicSocialMediaPlanDuplicationStatus/${deliverableId}`)
				.then(response => {
					if (response.data.is_duplicating) {
							this.$store.commit("setDuplicatingDeliverableJobKey", response.data.job_key);
							this.$store.commit("setDuplicatingDeliverableMessage", response.data.message);
							this.$store.commit('setDuplicatingDeliverableId', deliverableId);
							this.$store.commit("setDuplicatingDeliverableStatus", response.data.batch_status);
						// this.$store.dispatch('showDuplicationWarning', {
						// 	message: response.data.message,
						// 	startedBy: response.data.started_by,
						// 	progress: response.data.progress,
						// 	jobKey: response.data.job_key,
						// 	startedAt: response.data.started_at,
						// 	context: response.data.context,
						// 	jobMessage: response.data.job_message
						// });
					} else {
						this.$store.dispatch('hideDuplicationWarning');
						this.$store.commit('resetDuplicatingDeliverable');
						this.$store.commit('setDuplicatingDeliverableId', deliverableId);

					}
						this.duplicateDeliverableModalVisible = true;
				})
				.catch(error => {
					console.error('Error checking duplication status:', error);
				});
		},


	},
	created() {
	},
	mounted() {
		this.$root.$on("postModalClose", this.onPostModalClose);

		// Listen for global duplication monitoring trigger
		this.$root.$on('startGlobalDuplicationMonitoring', (jobKey) => {
			if (typeof jobKey === 'object' && jobKey !== null) {
				this.activeJobKey = jobKey.jobKey;
				this.startGlobalJobMonitoring(jobKey.jobKey, { queuePosition: jobKey.queuePosition });
			} else {
				this.activeJobKey = jobKey;
				this.startGlobalJobMonitoring(jobKey);
			}
		});

		// Listen for global organic social media monitoring trigger
		this.$root.$on('startGlobalDeliverableDuplicationMonitoring', (jobKey) => {
			if (typeof jobKey === 'object' && jobKey !== null) {
				this.startGlobalDeliverableDuplicationJobMonitoring(jobKey.jobKey, { queuePosition: jobKey.queuePosition });
			} else {
				this.activeOrganicSocialMediaPlanJobKey = jobKey;
				this.startGlobalDeliverableDuplicationJobMonitoring(jobKey);
			}
		});

		// this.$store.commit("setDuplicatingDeliverableNewDeliverableId", null);
		// this.$store.commit("setDuplicatingDeliverableId", this.deliverableId);
		// this.$bvModal.show("duplicateOrganicSocialMediaPlanModal");

		this.$root.$on('duplicateDeliverableModalOpened', () => {
			this.duplicateDeliverableModalVisible = true;
		});

		this.$root.$on('openDuplicateDeliverableModal', (data) => {
			this.checkOrganicSocialMediaPlanDuplicationStatus(data.deliverableId);
			console.log(data);
		});





		// Listen for duplicate modal visibility changes
		this.$root.$on('duplicateModalOpened', () => {
			this.duplicateModalVisible = true;
		});

		this.$root.$on('duplicateModalClosed', () => {
			this.duplicateModalVisible = false;
		});




		this.$root.$on("showEditOSMPModal", (deliverableId) => {
			this.$store.state.deliverables.editDeliverableModal = false;
			window.__switchingToOsmpModal = true;
			this.$bvModal.hide('editSocialModal');
			this.$bvModal.hide('editRelatedSocialModal');
			// compare if parent_deliverable_id in breadcrumb and namespaced deliverableDetail.id same
			if (this.deliverableDetail.id != deliverableId) {
				let that = this;
				this.$store.dispatch(this.namespace + 'getDeliverableDetail', { deliverableId: deliverableId }).then(function () {
					if (window.location.pathname.startsWith('/social-media-calendar')) {
						const queryString = window.location.search || '';
						window.history.replaceState({ osmpModal: true }, '', `/social-media-calendar/${deliverableId}${queryString}`);
					}
					that.$bvModal.show('editOrganicSocialMediaPlanModal');
					window.__switchingToOsmpModal = false;
				});
			} else {
				// if same, plan modal already open
				// then no api call to refetch same DeliverableDetail
				// close social media post modal, show the opened plan modal in focus 
				if (window.location.pathname.startsWith('/social-media-calendar')) {
					const queryString = window.location.search || '';
					window.history.replaceState({ osmpModal: true }, '', `/social-media-calendar/${deliverableId}${queryString}`);
				}
				this.$bvModal.show('editOrganicSocialMediaPlanModal');
				window.__switchingToOsmpModal = false;
			}
		});

		this.$root.$on('exportSocialMediaExcel', (customFilter) => {
			let that = this;
			if (customFilter) {
				this.showSocialMediaExportModal = true;
				this.isLoadingExport = true;
				this.downloadError = "";

				this.startDownloadDeliverableExcel(customFilter).then(function (response) {
					if (response.data.token != "") {
						that.downloadLink = process.env.MIX_API_BASE_URL + "downloadFile/" + response.data.token;
					} else {
						that.downloadLink = "";
						that.downloadError = "Invalid download token returned from server.";
					}
					that.isLoadingExport = false;
				});
			}
		});


		this.$root.$on('importSocialMediaExcel', (customFilter) => {
			let that = this;
			if (customFilter) {
				this.showSocialMediaImportModal = true;
				this.isLoadingImport = true;
				this.uploadError = "";
				this.importFilterQuery = customFilter;
			}
		});


		if (this.$router.currentRoute.name != 'dashboardMediaCalls') {
			if (this.isLoggedIn) {
				if (!this.preferenceData) {
					this.getPreference()
				}
				if (!this.systemSettings) {
					this.fetchSystemSettings()
				}
				this.fetchAllCompanies();
				this.fetchUserPermissions();
				this.fetchUserProjectsCount();
				this.fetchAllProjects();
				this.fetchWidgetSettings();

				// Check for active duplication jobs
				this.checkForActiveJobs();

				// let that = this;
				// let loadingNotifications = setInterval(function() {
				//   that.fetchAlerts();
				// }, 5000)
			}
		}
	},
	beforeDestroy() {
		// Clean up WebSocket channels if active
		if (this.activeJobKey) {
			window.Echo.leave(`project-duplication.${this.activeJobKey}`);
    }
  }
};
</script>
